import React from 'react'
import { Link as ReactRouterLink } from 'react-router-dom'
import { Box } from '@mui/material'
import Sparklogo from '../../../../assets/sparklogo.svg'

export const LogoLink: React.VFC = () => (
    <ReactRouterLink to="/">
        <Box
            sx={{
                padding: '12px 0 6px 0',
                display: 'flex',
                justifyContent: 'center',
            }}
        >
            <img src={Sparklogo} alt="logo" />
        </Box>
    </ReactRouterLink>
)

export default LogoLink
